import React from 'react';
import CollapsibleMenu from 'ui/properties-panel/collapsible-menu';
import InputGroup from './input-group';
import ColorSelection from './color-selection';
import FontStyleButtonGroup from 'ub/components/properties-panel/font-style-button-group';
import TextAlignmentButtonGroup from './style-tab-content-components/text-alignment-button-group';
import ParagraphStyleButtonGroup from './style-tab-content-components/paragraph-style-button-group';
import FontSize from 'ub/components/properties-panel/font-size';
import FontFamily from './style-tab-content-components/font-family';
import FontPickerFontFamily from './style-tab-content-components/font-picker-font-family';
import LineHeight from './style-tab-content-components/line-height';
import ParagraphStyle from './style-tab-content-components/paragraph-style';
import ubBanzai from 'ub/control/banzai-features';

const allowedStyles = [
  'bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript',
];

const newTag = ubBanzai.features.isFontPickerEnabled();

const StyleTabContent = (props) => {
  let fontFamily = (
    <FontFamily
      changeHandler={props.changeHandler}
      selectedFontFamily={props.fontFamily}
    />
  );

  if (ubBanzai.features.isFontPickerEnabled()) {
    fontFamily = (
      <FontPickerFontFamily
        changeHandler={props.changeHandler}
        selectedFontFamily={props.fontFamily}
        selectedWeight={props.fontWeight}
        selectedFontStyle={props.fontStyle}
        wide
      />
    );
  }

  return (
    <div className='style-contents'>
      <div className='paragraph-style-container'>
        <ParagraphStyle
          placeholder='No paragraph style'
          changeHandler={props.changeHandler}
          selectedValue={props.paragraphStyle}
        />
      </div>

      <CollapsibleMenu title='Font'>

        <div className='row-input-group family-size-input-group'>
          <InputGroup title='Family' newTag={newTag}>
            {fontFamily}
          </InputGroup>

          <InputGroup title='Size (px)'>
            <FontSize
              changeHandler={props.changeHandler}
              fontSize={props.fontSize}
            />
          </InputGroup>
        </div>

        <div className='row-input-group color-input-group'>
          <InputGroup title='Text Color' class='color-input-group text-color'>
            <ColorSelection
              changeProperty='fontColorChange'
              changeHandler={props.changeHandler}
              color={props.fontColor}
              name='text-color'
            />
          </InputGroup>

          <InputGroup title='Highlight Color' class='color-input-group background-color'>
            <ColorSelection
              changeProperty='fontBackgroundColorChange'
              changeHandler={props.changeHandler}
              color={props.fontBackgroundColor}
              showOpacity
              name='background-color'
            />
          </InputGroup>
        </div>

        <InputGroup title='Style'>
          <div className='input-items font-style-btn-group'>
            <FontStyleButtonGroup
              changeHandler={props.changeHandler}
              textStyles={props.textStyles}
              allowedStyles={allowedStyles}
            />
          </div>
        </InputGroup>
      </CollapsibleMenu>

      <CollapsibleMenu title='Paragraph'>
        <div className='row-input-group'>
          <InputGroup title='Alignment'>
            <div className='input-items'>
              <TextAlignmentButtonGroup
                changeHandler={props.changeHandler}
                alignment={props.alignment}
              />
            </div>
          </InputGroup>

          <InputGroup class='line-spacing' title='Line Height (px)'>
            <LineHeight
              changeHandler={props.changeHandler}
              lineHeight={props.lineHeight}
            />
          </InputGroup>
        </div>

        <InputGroup title='Style'>
          <div className='input-items paragraph-style-btn-group'>
            <ParagraphStyleButtonGroup
              listStyle={props.listStyle}
              changeHandler={props.changeHandler}
              inEditMode={props.inEditMode}
            />
          </div>
        </InputGroup>
      </CollapsibleMenu>
    </div>
  );
};

StyleTabContent.propTypes = {
  inEditMode: React.PropTypes.bool.isRequired,
  textStyles: React.PropTypes.object.isRequired,
  fontSize: React.PropTypes.number.isRequired,
  fontFamily: React.PropTypes.string.isRequired,
  fontWeight: React.PropTypes.number.isRequired,
  fontStyle: React.PropTypes.string.isRequired,
  lineHeight: React.PropTypes.number.isRequired,
  alignment: React.PropTypes.string.isRequired,
  paragraphStyle: React.PropTypes.string.isRequired,
  listStyle: React.PropTypes.string,
  changeHandler: React.PropTypes.func.isRequired,
  fontColor: React.PropTypes.object.isRequired,
  fontBackgroundColor: React.PropTypes.object.isRequired,
};

export default StyleTabContent;



// WEBPACK FOOTER //
// ./src/ui/inline-text/style-tab-content.jsx